import { Text, View } from '@gluestack-ui/themed'
import React, { FunctionComponent } from 'react'
import { Image, StyleSheet, TouchableOpacity } from 'react-native'
import { ActualiteItemResult } from '../../api/Actualites'
import { Routes } from '../../navigation/Routes'
import { toDDMMYYYYatHHMM } from '../../services/dateFormatter'
import { getItemAction } from '../../services/itemAction'
import { theme } from '../../theme'

interface NewsItemProps {
  item: ActualiteItemResult
}

export const NewsItem: FunctionComponent<NewsItemProps> = ({ item }) => {
  if (!item) {
    return null
  }
  const onPressProfil = () => {
    if (!item.author.action) {
      return
    }
    return getItemAction(item.author.action)
  }

  const date = `${item.author.libelle}, ${toDDMMYYYYatHHMM(item.date)}`

  const displayprofil = () => {
    if (!item.author.image) {
      return null
    }

    const profilImage = (
      <View>
        <Image resizeMode="cover" source={{ uri: item.author.image }} style={styles.profil} />
      </View>
    )

    if (!item.author.action) {
      return profilImage
    }

    return <TouchableOpacity onPress={onPressProfil}>{profilImage}</TouchableOpacity>
  }

  const handlePress = getItemAction({
    type: 'view',
    viewName: Routes.Actualite,
    params: { id: item.id, titre: item.libelle, image: item.image },
  })

  return (
    <TouchableOpacity style={styles.container} onPress={handlePress}>
      <View style={styles.header}>
        {displayprofil()}
        <Text style={styles.titre} numberOfLines={2}>
          {item.libelle}
        </Text>
      </View>
      {item.image && (
        <View>
          <Image source={{ uri: item.image }} resizeMode="cover" style={styles.image} />
        </View>
      )}

      <Text style={styles.description} numberOfLines={2}>
        {item.descriptionLight}
      </Text>
      <Text style={styles.date}>{date}</Text>
    </TouchableOpacity>
  )
}

const IMAGE_HEIGHT = 200
const RADIUS_IMAGE = 2
const SIZE_PROFIL = 50
const BORDER_WIDTH = 0.5

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingVertical: theme.padding.x2,
    justifyContent: 'space-around',
    borderBottomWidth: BORDER_WIDTH,
    borderBottomColor: theme.colors.silver,
  },
  header: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom: theme.padding.x1,
  },
  profil: {
    height: SIZE_PROFIL,
    width: SIZE_PROFIL,
    borderRadius: SIZE_PROFIL / 2,
    marginRight: theme.padding.x2,
  },
  titre: {
    flex: 1,
    textAlign: 'left',
    fontWeight: 'bold',
    fontSize: theme.textSize.x2,
  },
  image: {
    width: theme.deviceWidth - theme.padding.x4,
    height: IMAGE_HEIGHT,
    borderRadius: RADIUS_IMAGE,
    marginBottom: theme.padding.x1,
  },
  description: {
    color: theme.colors.black,
    textAlign: 'justify',
    marginBottom: theme.padding.x1,
  },
  date: {
    color: theme.colors.silver,
  },
})
